import {
    getAdminAllUsersQueryKey,
    getAdminAllUsersInfiniteQueryKey,
    useAdminAllUsersQuery,
    useAdminAllUsersInfiniteQuery,
    useAdminAllUsersMutation,
    getAdminCreateUserQueryKey,
    getAdminCreateUserInfiniteQueryKey,
    useAdminCreateUserQuery,
    useAdminCreateUserInfiniteQuery,
    useAdminCreateUserMutation,
    getAdminDashboardAttentionQueryKey,
    getAdminDashboardAttentionInfiniteQueryKey,
    useAdminDashboardAttentionQuery,
    useAdminDashboardAttentionInfiniteQuery,
    useAdminDashboardAttentionMutation,
    getAdminProductAnalyticsQueryKey,
    getAdminProductAnalyticsInfiniteQueryKey,
    useAdminProductAnalyticsQuery,
    useAdminProductAnalyticsInfiniteQuery,
    useAdminProductAnalyticsMutation,
    getAdminResolveAttentionQueryKey,
    getAdminResolveAttentionInfiniteQueryKey,
    useAdminResolveAttentionQuery,
    useAdminResolveAttentionInfiniteQuery,
    useAdminResolveAttentionMutation,
    getAdminRunAnalyticsQueryKey,
    getAdminRunAnalyticsInfiniteQueryKey,
    useAdminRunAnalyticsQuery,
    useAdminRunAnalyticsInfiniteQuery,
    useAdminRunAnalyticsMutation,
    getAdminUnresolveAttentionQueryKey,
    getAdminUnresolveAttentionInfiniteQueryKey,
    useAdminUnresolveAttentionQuery,
    useAdminUnresolveAttentionInfiniteQuery,
    useAdminUnresolveAttentionMutation,
    getAdminEbayAccountQueryKey,
    getAdminEbayAccountInfiniteQueryKey,
    useAdminEbayAccountQuery,
    useAdminEbayAccountInfiniteQuery,
    useAdminEbayAccountMutation,
    getAdminEbayCategorySuggestionsQueryKey,
    getAdminEbayCategorySuggestionsInfiniteQueryKey,
    useAdminEbayCategorySuggestionsQuery,
    useAdminEbayCategorySuggestionsInfiniteQuery,
    useAdminEbayCategorySuggestionsMutation,
    getAdminEbayConnectQueryKey,
    getAdminEbayConnectInfiniteQueryKey,
    useAdminEbayConnectQuery,
    useAdminEbayConnectInfiniteQuery,
    useAdminEbayConnectMutation,
    getAdminEbayConnectUrlQueryKey,
    getAdminEbayConnectUrlInfiniteQueryKey,
    useAdminEbayConnectUrlQuery,
    useAdminEbayConnectUrlInfiniteQuery,
    useAdminEbayConnectUrlMutation,
    getAdminEbayDeleteDraftQueryKey,
    getAdminEbayDeleteDraftInfiniteQueryKey,
    useAdminEbayDeleteDraftQuery,
    useAdminEbayDeleteDraftInfiniteQuery,
    useAdminEbayDeleteDraftMutation,
    getAdminEbayDisconnectQueryKey,
    getAdminEbayDisconnectInfiniteQueryKey,
    useAdminEbayDisconnectQuery,
    useAdminEbayDisconnectInfiniteQuery,
    useAdminEbayDisconnectMutation,
    getAdminEbayEndQueryKey,
    getAdminEbayEndInfiniteQueryKey,
    useAdminEbayEndQuery,
    useAdminEbayEndInfiniteQuery,
    useAdminEbayEndMutation,
    getAdminEbayListingQueryKey,
    getAdminEbayListingInfiniteQueryKey,
    useAdminEbayListingQuery,
    useAdminEbayListingInfiniteQuery,
    useAdminEbayListingMutation,
    getAdminEbayProductCategoryQueryKey,
    getAdminEbayProductCategoryInfiniteQueryKey,
    useAdminEbayProductCategoryQuery,
    useAdminEbayProductCategoryInfiniteQuery,
    useAdminEbayProductCategoryMutation,
    getAdminEbayPublishQueryKey,
    getAdminEbayPublishInfiniteQueryKey,
    useAdminEbayPublishQuery,
    useAdminEbayPublishInfiniteQuery,
    useAdminEbayPublishMutation,
    getAdminEbaySaveDraftQueryKey,
    getAdminEbaySaveDraftInfiniteQueryKey,
    useAdminEbaySaveDraftQuery,
    useAdminEbaySaveDraftInfiniteQuery,
    useAdminEbaySaveDraftMutation,
    getAdminEbaySellingLimitQueryKey,
    getAdminEbaySellingLimitInfiniteQueryKey,
    useAdminEbaySellingLimitQuery,
    useAdminEbaySellingLimitInfiniteQuery,
    useAdminEbaySellingLimitMutation,
    getAdminEbaySetupQueryKey,
    getAdminEbaySetupInfiniteQueryKey,
    useAdminEbaySetupQuery,
    useAdminEbaySetupInfiniteQuery,
    useAdminEbaySetupMutation,
    getAdminEbayVerifyQueryKey,
    getAdminEbayVerifyInfiniteQueryKey,
    useAdminEbayVerifyQuery,
    useAdminEbayVerifyInfiniteQuery,
    useAdminEbayVerifyMutation,
    getAdminGetAllPalletsQueryKey,
    getAdminGetAllPalletsInfiniteQueryKey,
    useAdminGetAllPalletsQuery,
    useAdminGetAllPalletsInfiniteQuery,
    useAdminGetAllPalletsMutation,
    getAdminCreateProductOrderQueryKey,
    getAdminCreateProductOrderInfiniteQueryKey,
    useAdminCreateProductOrderQuery,
    useAdminCreateProductOrderInfiniteQuery,
    useAdminCreateProductOrderMutation,
    getAdminGetOrdersByProductIDQueryKey,
    getAdminGetOrdersByProductIDInfiniteQueryKey,
    useAdminGetOrdersByProductIDQuery,
    useAdminGetOrdersByProductIDInfiniteQuery,
    useAdminGetOrdersByProductIDMutation,
    getAdminUpdateOrderStatusQueryKey,
    getAdminUpdateOrderStatusInfiniteQueryKey,
    useAdminUpdateOrderStatusQuery,
    useAdminUpdateOrderStatusInfiniteQuery,
    useAdminUpdateOrderStatusMutation,
    getAdminCreatePalletQueryKey,
    getAdminCreatePalletInfiniteQueryKey,
    useAdminCreatePalletQuery,
    useAdminCreatePalletInfiniteQuery,
    useAdminCreatePalletMutation,
    getAdminCreatePalletOrderAttachmentQueryKey,
    getAdminCreatePalletOrderAttachmentInfiniteQueryKey,
    useAdminCreatePalletOrderAttachmentQuery,
    useAdminCreatePalletOrderAttachmentInfiniteQuery,
    useAdminCreatePalletOrderAttachmentMutation,
    getAdminDeletePalletOrderAttachmentQueryKey,
    getAdminDeletePalletOrderAttachmentInfiniteQueryKey,
    useAdminDeletePalletOrderAttachmentQuery,
    useAdminDeletePalletOrderAttachmentInfiniteQuery,
    useAdminDeletePalletOrderAttachmentMutation,
    getAdminDownloadPalletOrderAttachmentQueryKey,
    getAdminDownloadPalletOrderAttachmentInfiniteQueryKey,
    useAdminDownloadPalletOrderAttachmentQuery,
    useAdminDownloadPalletOrderAttachmentInfiniteQuery,
    useAdminDownloadPalletOrderAttachmentMutation,
    getAdminGetPalletQueryKey,
    getAdminGetPalletInfiniteQueryKey,
    useAdminGetPalletQuery,
    useAdminGetPalletInfiniteQuery,
    useAdminGetPalletMutation,
    getAdminPalletOrderLookupQueryKey,
    getAdminPalletOrderLookupInfiniteQueryKey,
    useAdminPalletOrderLookupQuery,
    useAdminPalletOrderLookupInfiniteQuery,
    useAdminPalletOrderLookupMutation,
    getAdminUpdatePalletQueryKey,
    getAdminUpdatePalletInfiniteQueryKey,
    useAdminUpdatePalletQuery,
    useAdminUpdatePalletInfiniteQuery,
    useAdminUpdatePalletMutation,
    getAdminUpdatePalletOrderAttachmentMetadataQueryKey,
    getAdminUpdatePalletOrderAttachmentMetadataInfiniteQueryKey,
    useAdminUpdatePalletOrderAttachmentMetadataQuery,
    useAdminUpdatePalletOrderAttachmentMetadataInfiniteQuery,
    useAdminUpdatePalletOrderAttachmentMetadataMutation,
    getAdminPauseWorkerQueryKey,
    getAdminPauseWorkerInfiniteQueryKey,
    useAdminPauseWorkerQuery,
    useAdminPauseWorkerInfiniteQuery,
    useAdminPauseWorkerMutation,
    getAdminResumeWorkerQueryKey,
    getAdminResumeWorkerInfiniteQueryKey,
    useAdminResumeWorkerQuery,
    useAdminResumeWorkerInfiniteQuery,
    useAdminResumeWorkerMutation,
    getAdminRunWorkerJobQueryKey,
    getAdminRunWorkerJobInfiniteQueryKey,
    useAdminRunWorkerJobQuery,
    useAdminRunWorkerJobInfiniteQuery,
    useAdminRunWorkerJobMutation,
    getAdminWorkerJobsQueryKey,
    getAdminWorkerJobsInfiniteQueryKey,
    useAdminWorkerJobsQuery,
    useAdminWorkerJobsInfiniteQuery,
    useAdminWorkerJobsMutation,
    getAdminWorkerStatusQueryKey,
    getAdminWorkerStatusInfiniteQueryKey,
    useAdminWorkerStatusQuery,
    useAdminWorkerStatusInfiniteQuery,
    useAdminWorkerStatusMutation,
    getGetMeQueryKey,
    getGetMeInfiniteQueryKey,
    useGetMeQuery,
    useGetMeInfiniteQuery,
    useGetMeMutation,
    getPostAdminChangePasswordQueryKey,
    getPostAdminChangePasswordInfiniteQueryKey,
    usePostAdminChangePasswordQuery,
    usePostAdminChangePasswordInfiniteQuery,
    usePostAdminChangePasswordMutation,
    getPostAdminLogInQueryKey,
    getPostAdminLogInInfiniteQueryKey,
    usePostAdminLogInQuery,
    usePostAdminLogInInfiniteQuery,
    usePostAdminLogInMutation,
    getPostAdminRefreshAccessTokenQueryKey,
    getPostAdminRefreshAccessTokenInfiniteQueryKey,
    usePostAdminRefreshAccessTokenQuery,
    usePostAdminRefreshAccessTokenInfiniteQuery,
    usePostAdminRefreshAccessTokenMutation,
    getPostAdminRefreshRefreshTokenQueryKey,
    getPostAdminRefreshRefreshTokenInfiniteQueryKey,
    usePostAdminRefreshRefreshTokenQuery,
    usePostAdminRefreshRefreshTokenInfiniteQuery,
    usePostAdminRefreshRefreshTokenMutation,
    getAdminGroupSaleCreateQueryKey,
    getAdminGroupSaleCreateInfiniteQueryKey,
    useAdminGroupSaleCreateQuery,
    useAdminGroupSaleCreateInfiniteQuery,
    useAdminGroupSaleCreateMutation,
    getAdminGroupSaleDetailQueryKey,
    getAdminGroupSaleDetailInfiniteQueryKey,
    useAdminGroupSaleDetailQuery,
    useAdminGroupSaleDetailInfiniteQuery,
    useAdminGroupSaleDetailMutation,
    getAdminGroupSaleListQueryKey,
    getAdminGroupSaleListInfiniteQueryKey,
    useAdminGroupSaleListQuery,
    useAdminGroupSaleListInfiniteQuery,
    useAdminGroupSaleListMutation,
    getAdminGroupSaleUpdateQueryKey,
    getAdminGroupSaleUpdateInfiniteQueryKey,
    useAdminGroupSaleUpdateQuery,
    useAdminGroupSaleUpdateInfiniteQuery,
    useAdminGroupSaleUpdateMutation,
    getDeleteAdminDeleteImageQueryKey,
    getDeleteAdminDeleteImageInfiniteQueryKey,
    useDeleteAdminDeleteImageQuery,
    useDeleteAdminDeleteImageInfiniteQuery,
    useDeleteAdminDeleteImageMutation,
    getGetAdminDownloadProductImagesQueryKey,
    getGetAdminDownloadProductImagesInfiniteQueryKey,
    useGetAdminDownloadProductImagesQuery,
    useGetAdminDownloadProductImagesInfiniteQuery,
    useGetAdminDownloadProductImagesMutation,
    getGetAdminProductCategoryListQueryKey,
    getGetAdminProductCategoryListInfiniteQueryKey,
    useGetAdminProductCategoryListQuery,
    useGetAdminProductCategoryListInfiniteQuery,
    useGetAdminProductCategoryListMutation,
    getGetAdminProductDetailQueryKey,
    getGetAdminProductDetailInfiniteQueryKey,
    useGetAdminProductDetailQuery,
    useGetAdminProductDetailInfiniteQuery,
    useGetAdminProductDetailMutation,
    getGetAdminProductDownloadImageQueryKey,
    getGetAdminProductDownloadImageInfiniteQueryKey,
    useGetAdminProductDownloadImageQuery,
    useGetAdminProductDownloadImageInfiniteQuery,
    useGetAdminProductDownloadImageMutation,
    getGetAdminProductsConsistencyDetailsQueryKey,
    getGetAdminProductsConsistencyDetailsInfiniteQueryKey,
    useGetAdminProductsConsistencyDetailsQuery,
    useGetAdminProductsConsistencyDetailsInfiniteQuery,
    useGetAdminProductsConsistencyDetailsMutation,
    getPostAdminAssignProductsToGroupSaleQueryKey,
    getPostAdminAssignProductsToGroupSaleInfiniteQueryKey,
    usePostAdminAssignProductsToGroupSaleQuery,
    usePostAdminAssignProductsToGroupSaleInfiniteQuery,
    usePostAdminAssignProductsToGroupSaleMutation,
    getPostAdminAttachImagesQueryKey,
    getPostAdminAttachImagesInfiniteQueryKey,
    usePostAdminAttachImagesQuery,
    usePostAdminAttachImagesInfiniteQuery,
    usePostAdminAttachImagesMutation,
    getPostAdminPrintLabelQueryKey,
    getPostAdminPrintLabelInfiniteQueryKey,
    usePostAdminPrintLabelQuery,
    usePostAdminPrintLabelInfiniteQuery,
    usePostAdminPrintLabelMutation,
    getPostAdminProductCreateQueryKey,
    getPostAdminProductCreateInfiniteQueryKey,
    usePostAdminProductCreateQuery,
    usePostAdminProductCreateInfiniteQuery,
    usePostAdminProductCreateMutation,
    getPostAdminProductListQueryKey,
    getPostAdminProductListInfiniteQueryKey,
    usePostAdminProductListQuery,
    usePostAdminProductListInfiniteQuery,
    usePostAdminProductListMutation,
    getPostAdminRotateImageQueryKey,
    getPostAdminRotateImageInfiniteQueryKey,
    usePostAdminRotateImageQuery,
    usePostAdminRotateImageInfiniteQuery,
    usePostAdminRotateImageMutation,
    getPostAdminUpdateProductsStatusQueryKey,
    getPostAdminUpdateProductsStatusInfiniteQueryKey,
    usePostAdminUpdateProductsStatusQuery,
    usePostAdminUpdateProductsStatusInfiniteQuery,
    usePostAdminUpdateProductsStatusMutation,
    getPutAdminProductUpdateQueryKey,
    getPutAdminProductUpdateInfiniteQueryKey,
    usePutAdminProductUpdateQuery,
    usePutAdminProductUpdateInfiniteQuery,
    usePutAdminProductUpdateMutation,
} from './apis';

export const ApiQuery = {
    getAdminAllUsersQueryKey,
    getAdminAllUsersInfiniteQueryKey,
    useAdminAllUsersQuery,
    useAdminAllUsersInfiniteQuery,
    useAdminAllUsersMutation,
    getAdminCreateUserQueryKey,
    getAdminCreateUserInfiniteQueryKey,
    useAdminCreateUserQuery,
    useAdminCreateUserInfiniteQuery,
    useAdminCreateUserMutation,
    getAdminDashboardAttentionQueryKey,
    getAdminDashboardAttentionInfiniteQueryKey,
    useAdminDashboardAttentionQuery,
    useAdminDashboardAttentionInfiniteQuery,
    useAdminDashboardAttentionMutation,
    getAdminProductAnalyticsQueryKey,
    getAdminProductAnalyticsInfiniteQueryKey,
    useAdminProductAnalyticsQuery,
    useAdminProductAnalyticsInfiniteQuery,
    useAdminProductAnalyticsMutation,
    getAdminResolveAttentionQueryKey,
    getAdminResolveAttentionInfiniteQueryKey,
    useAdminResolveAttentionQuery,
    useAdminResolveAttentionInfiniteQuery,
    useAdminResolveAttentionMutation,
    getAdminRunAnalyticsQueryKey,
    getAdminRunAnalyticsInfiniteQueryKey,
    useAdminRunAnalyticsQuery,
    useAdminRunAnalyticsInfiniteQuery,
    useAdminRunAnalyticsMutation,
    getAdminUnresolveAttentionQueryKey,
    getAdminUnresolveAttentionInfiniteQueryKey,
    useAdminUnresolveAttentionQuery,
    useAdminUnresolveAttentionInfiniteQuery,
    useAdminUnresolveAttentionMutation,
    getAdminEbayAccountQueryKey,
    getAdminEbayAccountInfiniteQueryKey,
    useAdminEbayAccountQuery,
    useAdminEbayAccountInfiniteQuery,
    useAdminEbayAccountMutation,
    getAdminEbayCategorySuggestionsQueryKey,
    getAdminEbayCategorySuggestionsInfiniteQueryKey,
    useAdminEbayCategorySuggestionsQuery,
    useAdminEbayCategorySuggestionsInfiniteQuery,
    useAdminEbayCategorySuggestionsMutation,
    getAdminEbayConnectQueryKey,
    getAdminEbayConnectInfiniteQueryKey,
    useAdminEbayConnectQuery,
    useAdminEbayConnectInfiniteQuery,
    useAdminEbayConnectMutation,
    getAdminEbayConnectUrlQueryKey,
    getAdminEbayConnectUrlInfiniteQueryKey,
    useAdminEbayConnectUrlQuery,
    useAdminEbayConnectUrlInfiniteQuery,
    useAdminEbayConnectUrlMutation,
    getAdminEbayDeleteDraftQueryKey,
    getAdminEbayDeleteDraftInfiniteQueryKey,
    useAdminEbayDeleteDraftQuery,
    useAdminEbayDeleteDraftInfiniteQuery,
    useAdminEbayDeleteDraftMutation,
    getAdminEbayDisconnectQueryKey,
    getAdminEbayDisconnectInfiniteQueryKey,
    useAdminEbayDisconnectQuery,
    useAdminEbayDisconnectInfiniteQuery,
    useAdminEbayDisconnectMutation,
    getAdminEbayEndQueryKey,
    getAdminEbayEndInfiniteQueryKey,
    useAdminEbayEndQuery,
    useAdminEbayEndInfiniteQuery,
    useAdminEbayEndMutation,
    getAdminEbayListingQueryKey,
    getAdminEbayListingInfiniteQueryKey,
    useAdminEbayListingQuery,
    useAdminEbayListingInfiniteQuery,
    useAdminEbayListingMutation,
    getAdminEbayProductCategoryQueryKey,
    getAdminEbayProductCategoryInfiniteQueryKey,
    useAdminEbayProductCategoryQuery,
    useAdminEbayProductCategoryInfiniteQuery,
    useAdminEbayProductCategoryMutation,
    getAdminEbayPublishQueryKey,
    getAdminEbayPublishInfiniteQueryKey,
    useAdminEbayPublishQuery,
    useAdminEbayPublishInfiniteQuery,
    useAdminEbayPublishMutation,
    getAdminEbaySaveDraftQueryKey,
    getAdminEbaySaveDraftInfiniteQueryKey,
    useAdminEbaySaveDraftQuery,
    useAdminEbaySaveDraftInfiniteQuery,
    useAdminEbaySaveDraftMutation,
    getAdminEbaySellingLimitQueryKey,
    getAdminEbaySellingLimitInfiniteQueryKey,
    useAdminEbaySellingLimitQuery,
    useAdminEbaySellingLimitInfiniteQuery,
    useAdminEbaySellingLimitMutation,
    getAdminEbaySetupQueryKey,
    getAdminEbaySetupInfiniteQueryKey,
    useAdminEbaySetupQuery,
    useAdminEbaySetupInfiniteQuery,
    useAdminEbaySetupMutation,
    getAdminEbayVerifyQueryKey,
    getAdminEbayVerifyInfiniteQueryKey,
    useAdminEbayVerifyQuery,
    useAdminEbayVerifyInfiniteQuery,
    useAdminEbayVerifyMutation,
    getAdminGetAllPalletsQueryKey,
    getAdminGetAllPalletsInfiniteQueryKey,
    useAdminGetAllPalletsQuery,
    useAdminGetAllPalletsInfiniteQuery,
    useAdminGetAllPalletsMutation,
    getAdminCreateProductOrderQueryKey,
    getAdminCreateProductOrderInfiniteQueryKey,
    useAdminCreateProductOrderQuery,
    useAdminCreateProductOrderInfiniteQuery,
    useAdminCreateProductOrderMutation,
    getAdminGetOrdersByProductIDQueryKey,
    getAdminGetOrdersByProductIDInfiniteQueryKey,
    useAdminGetOrdersByProductIDQuery,
    useAdminGetOrdersByProductIDInfiniteQuery,
    useAdminGetOrdersByProductIDMutation,
    getAdminUpdateOrderStatusQueryKey,
    getAdminUpdateOrderStatusInfiniteQueryKey,
    useAdminUpdateOrderStatusQuery,
    useAdminUpdateOrderStatusInfiniteQuery,
    useAdminUpdateOrderStatusMutation,
    getAdminCreatePalletQueryKey,
    getAdminCreatePalletInfiniteQueryKey,
    useAdminCreatePalletQuery,
    useAdminCreatePalletInfiniteQuery,
    useAdminCreatePalletMutation,
    getAdminCreatePalletOrderAttachmentQueryKey,
    getAdminCreatePalletOrderAttachmentInfiniteQueryKey,
    useAdminCreatePalletOrderAttachmentQuery,
    useAdminCreatePalletOrderAttachmentInfiniteQuery,
    useAdminCreatePalletOrderAttachmentMutation,
    getAdminDeletePalletOrderAttachmentQueryKey,
    getAdminDeletePalletOrderAttachmentInfiniteQueryKey,
    useAdminDeletePalletOrderAttachmentQuery,
    useAdminDeletePalletOrderAttachmentInfiniteQuery,
    useAdminDeletePalletOrderAttachmentMutation,
    getAdminDownloadPalletOrderAttachmentQueryKey,
    getAdminDownloadPalletOrderAttachmentInfiniteQueryKey,
    useAdminDownloadPalletOrderAttachmentQuery,
    useAdminDownloadPalletOrderAttachmentInfiniteQuery,
    useAdminDownloadPalletOrderAttachmentMutation,
    getAdminGetPalletQueryKey,
    getAdminGetPalletInfiniteQueryKey,
    useAdminGetPalletQuery,
    useAdminGetPalletInfiniteQuery,
    useAdminGetPalletMutation,
    getAdminPalletOrderLookupQueryKey,
    getAdminPalletOrderLookupInfiniteQueryKey,
    useAdminPalletOrderLookupQuery,
    useAdminPalletOrderLookupInfiniteQuery,
    useAdminPalletOrderLookupMutation,
    getAdminUpdatePalletQueryKey,
    getAdminUpdatePalletInfiniteQueryKey,
    useAdminUpdatePalletQuery,
    useAdminUpdatePalletInfiniteQuery,
    useAdminUpdatePalletMutation,
    getAdminUpdatePalletOrderAttachmentMetadataQueryKey,
    getAdminUpdatePalletOrderAttachmentMetadataInfiniteQueryKey,
    useAdminUpdatePalletOrderAttachmentMetadataQuery,
    useAdminUpdatePalletOrderAttachmentMetadataInfiniteQuery,
    useAdminUpdatePalletOrderAttachmentMetadataMutation,
    getAdminPauseWorkerQueryKey,
    getAdminPauseWorkerInfiniteQueryKey,
    useAdminPauseWorkerQuery,
    useAdminPauseWorkerInfiniteQuery,
    useAdminPauseWorkerMutation,
    getAdminResumeWorkerQueryKey,
    getAdminResumeWorkerInfiniteQueryKey,
    useAdminResumeWorkerQuery,
    useAdminResumeWorkerInfiniteQuery,
    useAdminResumeWorkerMutation,
    getAdminRunWorkerJobQueryKey,
    getAdminRunWorkerJobInfiniteQueryKey,
    useAdminRunWorkerJobQuery,
    useAdminRunWorkerJobInfiniteQuery,
    useAdminRunWorkerJobMutation,
    getAdminWorkerJobsQueryKey,
    getAdminWorkerJobsInfiniteQueryKey,
    useAdminWorkerJobsQuery,
    useAdminWorkerJobsInfiniteQuery,
    useAdminWorkerJobsMutation,
    getAdminWorkerStatusQueryKey,
    getAdminWorkerStatusInfiniteQueryKey,
    useAdminWorkerStatusQuery,
    useAdminWorkerStatusInfiniteQuery,
    useAdminWorkerStatusMutation,
    getGetMeQueryKey,
    getGetMeInfiniteQueryKey,
    useGetMeQuery,
    useGetMeInfiniteQuery,
    useGetMeMutation,
    getPostAdminChangePasswordQueryKey,
    getPostAdminChangePasswordInfiniteQueryKey,
    usePostAdminChangePasswordQuery,
    usePostAdminChangePasswordInfiniteQuery,
    usePostAdminChangePasswordMutation,
    getPostAdminLogInQueryKey,
    getPostAdminLogInInfiniteQueryKey,
    usePostAdminLogInQuery,
    usePostAdminLogInInfiniteQuery,
    usePostAdminLogInMutation,
    getPostAdminRefreshAccessTokenQueryKey,
    getPostAdminRefreshAccessTokenInfiniteQueryKey,
    usePostAdminRefreshAccessTokenQuery,
    usePostAdminRefreshAccessTokenInfiniteQuery,
    usePostAdminRefreshAccessTokenMutation,
    getPostAdminRefreshRefreshTokenQueryKey,
    getPostAdminRefreshRefreshTokenInfiniteQueryKey,
    usePostAdminRefreshRefreshTokenQuery,
    usePostAdminRefreshRefreshTokenInfiniteQuery,
    usePostAdminRefreshRefreshTokenMutation,
    getAdminGroupSaleCreateQueryKey,
    getAdminGroupSaleCreateInfiniteQueryKey,
    useAdminGroupSaleCreateQuery,
    useAdminGroupSaleCreateInfiniteQuery,
    useAdminGroupSaleCreateMutation,
    getAdminGroupSaleDetailQueryKey,
    getAdminGroupSaleDetailInfiniteQueryKey,
    useAdminGroupSaleDetailQuery,
    useAdminGroupSaleDetailInfiniteQuery,
    useAdminGroupSaleDetailMutation,
    getAdminGroupSaleListQueryKey,
    getAdminGroupSaleListInfiniteQueryKey,
    useAdminGroupSaleListQuery,
    useAdminGroupSaleListInfiniteQuery,
    useAdminGroupSaleListMutation,
    getAdminGroupSaleUpdateQueryKey,
    getAdminGroupSaleUpdateInfiniteQueryKey,
    useAdminGroupSaleUpdateQuery,
    useAdminGroupSaleUpdateInfiniteQuery,
    useAdminGroupSaleUpdateMutation,
    getDeleteAdminDeleteImageQueryKey,
    getDeleteAdminDeleteImageInfiniteQueryKey,
    useDeleteAdminDeleteImageQuery,
    useDeleteAdminDeleteImageInfiniteQuery,
    useDeleteAdminDeleteImageMutation,
    getGetAdminDownloadProductImagesQueryKey,
    getGetAdminDownloadProductImagesInfiniteQueryKey,
    useGetAdminDownloadProductImagesQuery,
    useGetAdminDownloadProductImagesInfiniteQuery,
    useGetAdminDownloadProductImagesMutation,
    getGetAdminProductCategoryListQueryKey,
    getGetAdminProductCategoryListInfiniteQueryKey,
    useGetAdminProductCategoryListQuery,
    useGetAdminProductCategoryListInfiniteQuery,
    useGetAdminProductCategoryListMutation,
    getGetAdminProductDetailQueryKey,
    getGetAdminProductDetailInfiniteQueryKey,
    useGetAdminProductDetailQuery,
    useGetAdminProductDetailInfiniteQuery,
    useGetAdminProductDetailMutation,
    getGetAdminProductDownloadImageQueryKey,
    getGetAdminProductDownloadImageInfiniteQueryKey,
    useGetAdminProductDownloadImageQuery,
    useGetAdminProductDownloadImageInfiniteQuery,
    useGetAdminProductDownloadImageMutation,
    getGetAdminProductsConsistencyDetailsQueryKey,
    getGetAdminProductsConsistencyDetailsInfiniteQueryKey,
    useGetAdminProductsConsistencyDetailsQuery,
    useGetAdminProductsConsistencyDetailsInfiniteQuery,
    useGetAdminProductsConsistencyDetailsMutation,
    getPostAdminAssignProductsToGroupSaleQueryKey,
    getPostAdminAssignProductsToGroupSaleInfiniteQueryKey,
    usePostAdminAssignProductsToGroupSaleQuery,
    usePostAdminAssignProductsToGroupSaleInfiniteQuery,
    usePostAdminAssignProductsToGroupSaleMutation,
    getPostAdminAttachImagesQueryKey,
    getPostAdminAttachImagesInfiniteQueryKey,
    usePostAdminAttachImagesQuery,
    usePostAdminAttachImagesInfiniteQuery,
    usePostAdminAttachImagesMutation,
    getPostAdminPrintLabelQueryKey,
    getPostAdminPrintLabelInfiniteQueryKey,
    usePostAdminPrintLabelQuery,
    usePostAdminPrintLabelInfiniteQuery,
    usePostAdminPrintLabelMutation,
    getPostAdminProductCreateQueryKey,
    getPostAdminProductCreateInfiniteQueryKey,
    usePostAdminProductCreateQuery,
    usePostAdminProductCreateInfiniteQuery,
    usePostAdminProductCreateMutation,
    getPostAdminProductListQueryKey,
    getPostAdminProductListInfiniteQueryKey,
    usePostAdminProductListQuery,
    usePostAdminProductListInfiniteQuery,
    usePostAdminProductListMutation,
    getPostAdminRotateImageQueryKey,
    getPostAdminRotateImageInfiniteQueryKey,
    usePostAdminRotateImageQuery,
    usePostAdminRotateImageInfiniteQuery,
    usePostAdminRotateImageMutation,
    getPostAdminUpdateProductsStatusQueryKey,
    getPostAdminUpdateProductsStatusInfiniteQueryKey,
    usePostAdminUpdateProductsStatusQuery,
    usePostAdminUpdateProductsStatusInfiniteQuery,
    usePostAdminUpdateProductsStatusMutation,
    getPutAdminProductUpdateQueryKey,
    getPutAdminProductUpdateInfiniteQueryKey,
    usePutAdminProductUpdateQuery,
    usePutAdminProductUpdateInfiniteQuery,
    usePutAdminProductUpdateMutation,
};
